module.exports = " <div class=container :class=classes _v-3972ea98=\"\"> <slot _v-3972ea98=\"\"></slot> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-3972ea98!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Container.vue
// module id = 754
// module chunks = 2